module.exports = __webpack_public_path__ + "static/media/tips1@2x.d36c22d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/tips1@2x.png
// module id = 1245
// module chunks = 0